// import configApi from '@/api/sys/config'

const sys = {
	state: {
		title: '智慧校园管理系统',
		version: '',
		login: '',
		company: '',
		initConfig: false,
		pageSize: 10,//列表的默认页容量
		permissionRouters: [],//权限路由表
		permissionMenus: []//权限菜单列表
	},
	getters: {

	},
	mutations: {
		SET_INITCONFIG(state, initConfig) {
			state.initConfig = initConfig
		},
		SET_VERSION(state, version) {
			state.version = version
		},
		SET_LOGIN(state, login) {
			state.login = login
		},
		SET_TITLE(state, title) {
			state.title = title
		},
		SET_COMPANY(state, company) {
			state.company = company
		},
		SET_PERMISSION_ROUTERS(state, routers) {
			state.permissionRouters = routers;
		},
		SET_PERMISSION_MENUS(state, menus) {
			state.permissionMenus = menus;
		}
	},
	actions: {
		initSysConfig({ state, commit }, path) {
			return new Promise((resolve, reject) => {
				resolve()
			})
		}
	}
}
export default sys
